import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Tabs,
  Tab
} from 'react-bootstrap'


import Completed from './tasks/completed'
import Pending from './tasks/pending'
/* import Postponed from './tasks/postponed' */


@observer(['tasks'])
export default class Tasks extends Component {
  constructor(props) {
    super(props)

    this.props.tasks.loadTaskStates()
    this.props.tasks.loadAllTaskPriorities()
  }

  render() {

    let defaultTab = 1

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="clearfix"></div>
          <Tabs defaultActiveKey={ defaultTab } id="site-options-tabs">
            <Tab eventKey={ 1 } title="Pending">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
              <Pending />
              </div>
            </Tab>
            { /*
            <Tab eventKey={ 2 } title="Postponed">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
              <Postponed />
              </div>
            </Tab>
            */ }
            <Tab eventKey={ 2 } title="Completed">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
              <Completed />
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tasks.js